import '../stylesheets/LinksPage.css';

const LinkRow = ({ title, description, link, icon, isExternal }) => (
    <a
        href={link}
        className="link-row"
        target={isExternal ? "_blank" : "_self"}
        rel={isExternal ? "noopener noreferrer" : ""}
    >
        <div className="row-icon">{icon}</div>
        <div className="row-content">
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
        <div className="row-action">
            <svg viewBox="0 0 24 24" width="20" height="20">
                <path fill="currentColor" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
            </svg>
        </div>
    </a>
);

export function LinksPage() {
    return (
        <div className='LinksPage'>
            <h1 className="page-title">Օգտակար հղումներ</h1>
            <div className="links-list">
                <LinkRow
                    title="Ամսաթերթի անգլերեն տարբերակը"
                    description="Համար 1"
                    link="./journals/tert-english-12-2022.pdf"
                    isExternal={true}
                    icon={<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" /></svg>}
                />
                <LinkRow
                    title="Հայերեն Unicode փոխարկիչ"
                    description="Ամսագրի հին համարներից հայերեն տեքստերը փոխարկելու համար"
                    link="/unicode_converter.html"
                    isExternal={false}
                    icon={<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M12.89 3L14.85 3.4L11.11 21L9.15 20.6L12.89 3M19.59 12L16 8.41V5.58L22.42 12L16 18.41V15.58L19.59 12M1.58 12L8 5.58V8.41L4.41 12L8 15.58V18.41L1.58 12Z" /></svg>}
                />
                <LinkRow
                    title="Հայերեն Աստվածաշունչ"
                    description="Աստվածաշնչի առցանց տարբերակը"
                    link="http://barilur.org/bible/"
                    isExternal={true}
                    icon={<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l2.5-1.88L12 13V4h6v16z" /></svg>}
                />
                <LinkRow
                    title="Հոգեւոր երգարան"
                    description="ԱՀՔ Երգարանի առցանց տարբերակը"
                    link="https://ergaran.org"
                    isExternal={true}
                    icon={<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" /></svg>}
                />
            </div>
        </div>
    )
}
